import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { ItineraryPartner } from './itinerary-partner-entity';
import { Branch } from '../control-tables/branch-entity';

export class Itinerary extends BaseEntity {

    itineraryCode     : string;
    name              : string;
    rank              : number;
    branch            : Branch;
    
    itineraryPartners : ItineraryPartner[];


    // Transient
    selected         : boolean = false;
}